var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSadBlueFace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7409_102526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.5103 0H18.4897C8.27814 0 0 8.27814 0 18.4897V61.5103C0 71.7219 8.27814 80 18.4897 80H61.5103C71.7219 80 80 71.7219 80 61.5103V18.4897C80 8.27814 71.7219 0 61.5103 0Z",
    fill: "#5984FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7654 57.6198C56.6129 57.6198 57.9912 55.8749 57.5122 54.0909C55.7283 47.4389 49.0127 42.4976 40.9971 42.4976C32.9814 42.4976 26.2659 47.4438 24.4819 54.0909C24.0029 55.8749 25.3812 57.6198 27.2287 57.6198L37.6882 56.2219C39.7801 55.9433 41.9013 55.9384 43.998 56.2121L54.7654 57.6198Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9844 27.1163C28.6657 25.958 29.9853 24.3597 31.4027 22.8886C31.6178 22.6637 31.8573 22.434 32.1652 22.3851C32.5806 22.3265 32.9765 22.6491 33.1281 23.0401C33.2796 23.4311 33.2405 23.8661 33.1672 24.2815C32.5513 27.9228 29.8631 30.9433 26.7058 32.8592C25.0244 33.8807 23.1525 34.653 21.1877 34.8094C19.3695 34.956 17.3265 34.5406 15.8895 33.3529C14.653 32.3314 13.9883 30.6158 15.738 29.8974C17.1945 29.3011 19.4721 29.6383 21.0459 29.3597C23.1476 28.9834 25.2199 28.3382 26.9941 27.1212L26.9844 27.1163Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0156 27.1163C51.3343 25.958 50.0147 24.3597 48.5973 22.8886C48.3822 22.6637 48.1427 22.434 47.8348 22.3851C47.4194 22.3265 47.0235 22.6491 46.8719 23.0401C46.7204 23.4311 46.7595 23.8661 46.8328 24.2815C47.4487 27.9228 50.1369 30.9433 53.2942 32.8592C54.9756 33.8807 56.8475 34.653 58.8123 34.8094C60.6305 34.956 62.6735 34.5406 64.1105 33.3529C65.347 32.3314 66.0117 30.6158 64.262 29.8974C62.8055 29.3011 60.5279 29.6383 58.9541 29.3597C56.8524 28.9834 54.7801 28.3382 53.0059 27.1212L53.0156 27.1163Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7409_102526"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadBlueFace);
export default __webpack_public_path__ + "static/media/sadBlueFace.9fbd3ed1c7c81372c6137f731ef3d664.svg";
export { ForwardRef as ReactComponent };